import { Loader, OnLoad } from 'logard';

export default abstract class AbstractContext {
  readonly freeHooks: Array<() => void> = [];

  free(): void {
    this.freeHooks.forEach(f => f());
    this.freeHooks.splice(0);
  }
}

export class ContextLoader<Context extends AbstractContext | undefined> extends Loader<Context> {
  constructor(onLoad: OnLoad<Context>) {
    super(onLoad, c => c?.free());
  }
}